import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone, { OwnProps } from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentLocation: getLocation(state),
});

const mapDispatchToProps = {};

type Props = WidgetProps & OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface GAIASignInHereStyles {
    wrapper?: InjectableCss;
}

export const signInHereStyles: GAIASignInHereStyles = {
    wrapper: {
        css: css`
            background-color: transparent;
            display: flex;
            width: 100%;
            position: absolute;
            z-index: 1;
            > div[class^="Wrapper"] {
                > div[class^="ContentWrapper"] {
                    p {
                        color: ${getColor("primary")};
                        float: right;
                        padding: 0.5rem 1.5rem 0.5rem 5rem;
                        border-radius: 0 0 0 50px;
                        background: transparent linear-gradient(264deg, #c4d6a4 0%, #93c90e 100%) 0% 0% no-repeat
                            padding-box;
                    }
                }
            }
        `,
    },
};

const styles = signInHereStyles;

export const GAIASignInHere = ({ id, currentLocation }: Props) => {
    const url = currentLocation.pathname + currentLocation.search;
    return (
        <>
            {url === "/" ? (
                <StyledWrapper {...styles.wrapper} className="onScrollHeaderStrip">
                    <Zone contentId={id} zoneName="SignInHere" />
                </StyledWrapper>
            ) : null}
        </>
    );
};

const SignInHere: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(GAIASignInHere),
    definition: {
        group: "Common",
        displayName: "GAIA Sign In Here Strip",
        icon: "link-simple",
    },
};

export default SignInHere;
